import { render, staticRenderFns } from "./tiedCardApprove.vue?vue&type=template&id=d67b52ba"
import script from "./tiedCardApprove.vue?vue&type=script&lang=js"
export * from "./tiedCardApprove.vue?vue&type=script&lang=js"
import style0 from "./tiedCardApprove.vue?vue&type=style&index=0&id=d67b52ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports